import React from "react";
import styled from "styled-components";
import vagasBlue from "../../assets/vagasBlue.png";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #FFFEF9;
  border-bottom: 1px solid #ddd;
  width: 100%;
`;

const Text = styled.div`
  display: flex;
  align-items: center;
`;

const WelcomeText = styled.div`
  font-size: 18px; /* Tamanho padronizado */
  color: #002E3B;
  font-weight: 600;
  margin-left: 45px;
`;

const CadastrarVagasText = styled.div`
  font-size: 18px; /* Tamanho padronizado */
  color: #FF9F1F;
  font-weight: bold;
  margin-left: 10px;
`;

const BemVindoWrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const EstabelecimentoSaudeHeader = () => {
  return (
    <BemVindoWrapper>
      <Container>
        <Text>
          <WelcomeText>ES</WelcomeText>
          <img src={vagasBlue} alt="Especialidades" style={{ marginLeft: "10px", width: "40px", height: "40px", marginTop: "5px" }} />
          <CadastrarVagasText>Estabelecimento de Saúde</CadastrarVagasText>
        </Text>
      </Container>
    </BemVindoWrapper>
  );
};

export default EstabelecimentoSaudeHeader;